import React from "react";
import { getCardDescriptionText } from "@qlik/qlik/src/lib/util/helpers";

/**
 * SingleCardLeftIcon component
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.title - The title of the card.
 * @param {string} props.description - The description of the card.
 * @returns {JSX.Element} The rendered component.
 */
const SingleCardLeftIcon = ({ data }) => {
    const { title } = data ?? {};
    const description = getCardDescriptionText(data);

    // Render a div with the card's title and description
    return (
        <div className="h-full pl-11.25 pb-7 pr-0.5 border-b border-solid border-stone/50 relative after:list-item-icon-3 after:absolute after:left-0.5 after:top-0.5">
            {title && <h3 className="title-5 mb-3.75">{title}</h3>}
            {description && <p>{description}</p>}
        </div>
    );
};

export default SingleCardLeftIcon;
